import { render } from "./SubMenu2.vue?vue&type=template&id=6cc62125&scoped=true"
import script from "./SubMenu2.vue?vue&type=script&lang=js"
export * from "./SubMenu2.vue?vue&type=script&lang=js"

import "./SubMenu2.vue?vue&type=style&index=0&id=6cc62125&scoped=true&lang=css"
import "./SubMenu2.vue?vue&type=style&index=1&id=6cc62125&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc62125"]])

export default __exports__